import { getDictPhrase } from "../../../common";
import { getSelectionTitleOutrightProps, isSelectionNotFixture } from "../../selection";
export const getSelectionTitleProps = (bet, selection, state) => {
    if (isSelectionNotFixture(selection)) {
        return getSelectionTitleOutrightProps(bet, selection, state);
    }
    return {
        name: selection.selectionDisplayName,
        odds: selection.displayOdds || getDictPhrase(state.dict, "NotAvailable")
    };
};
//# sourceMappingURL=getSelectionTitleProps.js.map